import { create } from 'zustand'

import { AUTHENTICATE_OPTION, AUTHENTICATE_OPTION_LOGIN } from '@apps-common/config/authenticate-options'

export interface IAuthenticateScreenStore {
  screen: AUTHENTICATE_OPTION
  setScreen: (screen: AUTHENTICATE_OPTION) => void
  resetScreen: () => void
}

export const useAuthenticateScreenStore = create<IAuthenticateScreenStore>((set, get) => ({
  screen: AUTHENTICATE_OPTION_LOGIN,
  setScreen: (screen: AUTHENTICATE_OPTION) => set({ screen }),
  resetScreen: () => set({ screen: AUTHENTICATE_OPTION_LOGIN })
}))
